<header role="banner">
  <go-toolbar></go-toolbar>
</header>
<go-navbar></go-navbar>
<announcements></announcements>
<help-floater></help-floater>
<spinner></spinner>
<div id="main-content" class="overflow-hidden">
	<router-outlet></router-outlet>
</div>
<alert-modal></alert-modal>
<custom-alert-modal></custom-alert-modal>
<confirm-modal></confirm-modal>
<notify-modal></notify-modal>
<print-modal></print-modal>
<go-footer></go-footer>
<app-comparison-stepper-modal [id]="'comparison-wizard'"></app-comparison-stepper-modal>
<consider-tsa-modal></consider-tsa-modal>
<tsa-site-leaving></tsa-site-leaving>
<app-mobile-info-modal></app-mobile-info-modal>



